<template>
  <div v-if="show" class="info-overlay">
    <div class="info-content">
      <slot></slot>

    </div>
    <div class="info-footer">
      <button @click="$emit('update:show', false)">Ok</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InfoOverlay',

  props: {
    show: {
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/variables.scss';

.info-overlay {
    position: absolute;
    left: $info-overlay-margin;
    right: $info-overlay-margin;
    top: $info-overlay-margin;
    bottom: $info-overlay-margin;
    background-color: rgba(0, 0, 0, .7);
    display: flex;
    flex-direction: column;
    color: #E6E6E6;

    .info-content {
        padding: 10px;
        overflow-y: auto;
    }

    .info-footer {
      height: 80px;
      display: flex;
      justify-content: center;
      align-items: center;

        button {
            border-radius: 3px;
            background-color: rgba(0, 0, 0, 0);
            color: #e6e6e6;
            padding: 5px;
            border: 1px solid #e6e6e6;
        }
    }
}
</style>
